import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { RootState } from "../../state";
import { Shirt } from "../../entities/Shirt";
import { User } from "../../entities/User";
import ShirtsService from "../../services/shirts/shirtsService";
import { TopItem } from "../../services/shirts/types";
import UserService from "../../services/userService";
import NotificationService from "../../components/Notification/notificationService";
import Top10Element from "../../components/Top10Element/Top10Element";

const Top10 = () => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const [items, setItems] = useState<Array<TopItem> | undefined>(undefined);
  const [shirtCollection, setShirtCollection] = useState<
    Array<Shirt> | undefined
  >(undefined);
  const [ownPage, setOwnPage] = useState<boolean>(false);

  const { userId } = useParams();

  const { searchShirts, getTop10, addItemTop10, deleteItemTop10 } =
    ShirtsService();
  const { success, error } = NotificationService();
  const { getUserDetails } = UserService();

  const loginData = useSelector((state: RootState) => state.login);

  const deleteItem = (position: number) => {
    if (items) {
      const shirtToDelete = items.find((item) => item.position === position);
      if (shirtToDelete?.item.id) {
        deleteItemTop10(shirtToDelete?.item.id).then((result) => {
          if (result) {
            const itemsUpdated = [
              ...items.filter((item) => item.position !== position),
            ];
            setItems(itemsUpdated);

            const shirtsCollectionUpdated = shirtCollection
              ? [...shirtCollection]
              : [];
            shirtsCollectionUpdated.push(shirtToDelete.item);
            setShirtCollection(shirtsCollectionUpdated);

            success("Top shirt deleted successfully");
          } else {
            error("Error deleting shirt from Top 10");
          }
        });
      }
    }
  };

  const addItem = (shirt: Shirt, position: number) => {
    if (items && shirt.id) {
      addItemTop10(shirt.id, position).then((result) => {
        if (result) {
          const itemsUpdated = [
            ...items.filter((item) => item.position !== position),
          ];
          itemsUpdated.push({ item: shirt, position: position } as TopItem);
          setItems(itemsUpdated);

          const shirtsCollectionUpdated = shirtCollection
            ? [...shirtCollection.filter((item) => item.id !== shirt.id)]
            : [];
          setShirtCollection(shirtsCollectionUpdated);

          success("Top shirt added successfully");
        } else {
          error("Error adding shirt to Top 10");
        }
      });
    }
  };

  useEffect(() => {
    if (userId && parseInt(userId) !== loginData.userId) {
      getUserDetails(parseInt(userId)).then((result) => {
        if (result) {
          setUser(result);
          setOwnPage(false);
        }
      });
    } else {
      setUser(loginData);
      setOwnPage(true);
    }
  }, [userId]);

  useEffect(() => {
    if (user?.userId) {
      const userId = user.userId;
      getTop10(userId).then((resultsTop) => {
        setItems(resultsTop);
        searchShirts({
          user_id: userId,
          page: 1,
          perPage: 50,
        }).then((results) => {
          const idsInItems = resultsTop
            ? resultsTop.map((item) => item.item.id)
            : [];
          const filtered = results.shirts.filter(
            (item) => !idsInItems.includes(item.id)
          );
          setShirtCollection(filtered);
        });
      });
    }
  }, [user]);

  return (
    <>
      {items && shirtCollection
        ? Array.from({ length: 10 }, (_, index) => (
            <Box
              sx={{ marginBottom: "1rem", borderRadius: "10px" }}
              className="shadow-box"
            >
              <Top10Element
                userName={user?.userName ? user.userName : "Shirt detail"}
                position={index + 1}
                key={index + 1}
                shirt={items.find((item) => item.position === index + 1)?.item}
                add={ownPage ? addItem : undefined}
                remove={ownPage ? deleteItem : undefined}
                shirtCollection={shirtCollection}
              />
            </Box>
          ))
        : Array.from({ length: 10 }, (_, index) => (
            <Box key={index} marginBottom={"14px"}>
              <Skeleton variant="rectangular" height={100} />
            </Box>
          ))}
    </>
  );
};

export default Top10;
